import { EnterTracking } from '@/components/EnterTracking';
import Footer from '@/components/Footer';
import { useLocale } from '@/hooks';
import { useIsLoggerUserInfoSet } from '@/lib/auth/UserContext';
import { Achievement, Ai, AwardSection, Cta, GoogleEducation, Introduction, Pricing, Review, Students, Teacher } from '@/module/landing/components';
import { ViewTracking } from '@/shared/components/ViewTracking';
import { useClassroomPromotionModal } from '@/shared/features/classroom/hooks';
import { usePhoneVerificationBannerModal } from '@/shared/features/phone-verification-banner';
import { AiPromptGenerator } from './features/ai-prompt-generator/components';
const VIEW_EVENT = 'view_landing_section';
export function LandingPageView() {
  const {
    locale
  } = useLocale();
  const isLoggerUserInfoSet = useIsLoggerUserInfoSet();
  usePhoneVerificationBannerModal();
  useClassroomPromotionModal('landing_auto_promotion');
  return <EnterTracking eventName="enter_landing" isReady={isLoggerUserInfoSet} data-sentry-element="EnterTracking" data-sentry-component="LandingPageView" data-sentry-source-file="LandingPageView.tsx">
      <div className="flex flex-col gap-md min-[751px]:gap-2xl min-[1025px]:gap-3xl">
        <ViewTracking eventName={VIEW_EVENT} eventProperties={{
        section: 'cta'
      }} once={false} data-sentry-element="ViewTracking" data-sentry-source-file="LandingPageView.tsx">
          <Cta data-sentry-element="Cta" data-sentry-source-file="LandingPageView.tsx" />
        </ViewTracking>
        <ViewTracking eventName={VIEW_EVENT} eventProperties={{
        section: 'ai_prompt'
      }} once={false} data-sentry-element="ViewTracking" data-sentry-source-file="LandingPageView.tsx">
          <AiPromptGenerator data-sentry-element="AiPromptGenerator" data-sentry-source-file="LandingPageView.tsx" />
        </ViewTracking>
        <ViewTracking eventName={VIEW_EVENT} eventProperties={{
        section: 'introduction'
      }} once={false} data-sentry-element="ViewTracking" data-sentry-source-file="LandingPageView.tsx">
          <Introduction data-sentry-element="Introduction" data-sentry-source-file="LandingPageView.tsx" />
        </ViewTracking>
        <ViewTracking eventName={VIEW_EVENT} eventProperties={{
        section: 'award'
      }} once={false} data-sentry-element="ViewTracking" data-sentry-source-file="LandingPageView.tsx">
          <AwardSection locale={locale} data-sentry-element="AwardSection" data-sentry-source-file="LandingPageView.tsx" />
        </ViewTracking>
        <ViewTracking eventName={VIEW_EVENT} eventProperties={{
        section: 'achievement'
      }} once={false} data-sentry-element="ViewTracking" data-sentry-source-file="LandingPageView.tsx">
          <Achievement data-sentry-element="Achievement" data-sentry-source-file="LandingPageView.tsx" />
        </ViewTracking>
        <ViewTracking eventName={VIEW_EVENT} eventProperties={{
        section: 'google_education'
      }} once={false} data-sentry-element="ViewTracking" data-sentry-source-file="LandingPageView.tsx">
          <GoogleEducation data-sentry-element="GoogleEducation" data-sentry-source-file="LandingPageView.tsx" />
        </ViewTracking>
        <ViewTracking eventName={VIEW_EVENT} eventProperties={{
        section: 'review'
      }} once={false} data-sentry-element="ViewTracking" data-sentry-source-file="LandingPageView.tsx">
          <Review data-sentry-element="Review" data-sentry-source-file="LandingPageView.tsx" />
        </ViewTracking>
        <ViewTracking eventName={VIEW_EVENT} eventProperties={{
        section: 'teacher'
      }} once={false} data-sentry-element="ViewTracking" data-sentry-source-file="LandingPageView.tsx">
          <Teacher data-sentry-element="Teacher" data-sentry-source-file="LandingPageView.tsx" />
        </ViewTracking>
        <ViewTracking eventName={VIEW_EVENT} eventProperties={{
        section: 'ai_features'
      }} once={false} data-sentry-element="ViewTracking" data-sentry-source-file="LandingPageView.tsx">
          <Ai data-sentry-element="Ai" data-sentry-source-file="LandingPageView.tsx" />
        </ViewTracking>
        <ViewTracking eventName={VIEW_EVENT} eventProperties={{
        section: 'students'
      }} once={false} data-sentry-element="ViewTracking" data-sentry-source-file="LandingPageView.tsx">
          <Students data-sentry-element="Students" data-sentry-source-file="LandingPageView.tsx" />
        </ViewTracking>
        <ViewTracking eventName={VIEW_EVENT} eventProperties={{
        section: 'pricing'
      }} once={false} data-sentry-element="ViewTracking" data-sentry-source-file="LandingPageView.tsx">
          <Pricing data-sentry-element="Pricing" data-sentry-source-file="LandingPageView.tsx" />
          <Footer data-sentry-element="Footer" data-sentry-source-file="LandingPageView.tsx" />
        </ViewTracking>
      </div>
    </EnterTracking>;
}